// Returns a random integer between min (included) and max (excluded)
export function getRandomInt(min: number, max: number) {
    const minRounded = Math.ceil(min);
    const maxRounded = Math.floor(max);

    return Math.floor(Math.random() * (maxRounded - minRounded)) + minRounded;
}
